import { render, staticRenderFns } from "./FormAddInventoryCover.vue?vue&type=template&id=3e624150"
import script from "./FormAddInventoryCover.vue?vue&type=script&lang=js"
export * from "./FormAddInventoryCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports